export { default as AppHeader } from "./header";
export { default as CircularProgress } from "./circularprogress";
export { default as Footer } from "./footer";
export { default as SideMenu } from "./sidemenu";
export { default as StarRating } from "./star-rating"; 
export { default as Loader } from "./loader";
export { default as GoogleTagManager } from "./googletagmanager";
export { default as Wrapper } from "./wrapper";
export { default as Modal } from "./modal";
export { Switch } from "./switch";
export { default as MobileHeader } from "./mobile-header";
export { default as MobileFooter } from "./mobile-footer";
export * from "./homepage";
